import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Necesito saber de matemáticas o contabilidad?',
  answer: 'No. Si sabes usar un smartphone y leer un correo, puedes aplicar este sistema. Es psicología conductual, no contabilidad.'
}, {
  question: '¿Tengo que comprar más aplicaciones?',
  answer: 'No. Usaremos herramientas gratuitas que ya tienes en tu teléfono.'
}, {
  question: '¿Cuánto tiempo me tomará ver resultados?',
  answer: 'Los resultados son inmediatos. Tan pronto como cancelas tu primera suscripción o bloqueas un recargo, ya has ganado.'
}, {
  question: '¿Y si vuelvo a recaer en compras impulsivas?',
  answer: 'El sistema incluye un "enfriador de dopamina" diseñado específicamente para interrumpir el bucle de compra antes de que le des al botón de pagar.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-brand-cream" data-id="element-26">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-27">
        <FadeIn data-id="element-28">
          <div className="text-center mb-16" data-id="element-29">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-teal mb-4" data-id="element-30">
              Preguntas Frecuentes
            </h2>
            <div className="w-16 h-[2px] bg-brand-gold mx-auto" data-id="element-31"></div>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-32">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-33">
              <div className="bg-white rounded-xl border border-brand-teal/10 overflow-hidden" data-id="element-34">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-inset" aria-expanded={openIndex === index} data-id="element-35">
                  <span className="font-serif font-bold text-lg text-brand-teal pr-8" data-id="element-36">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="flex-shrink-0 text-brand-gold" data-id="element-37">
                    <ChevronDownIcon className="w-5 h-5" data-id="element-38" />
                  </motion.div>
                </button>

                <AnimatePresence initial={false} data-id="element-39">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-40">
                      <div className="px-6 pb-5 text-brand-charcoal/80" data-id="element-41">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}